export default __webpack_public_path__ + "e476728a9f6c407ed6963262d8d2b31b.jpg";